module.exports = __webpack_public_path__ + "img/lunar1.73ded198.jpg";